import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_USER = `${BASE_URL}/api/auth`;

export class UserApi {
  static async login(authRequest) {
    return await axiosInstance.post(`${BASE_URL_USER}/login`, authRequest);
  }

  static async signUp(authRequest) {
    return await axiosInstance.post(`${BASE_URL_USER}/signup`, authRequest);
  }

  static async logout() {
    return await axiosInstance.post(`${BASE_URL_USER}/logout`);
  }
}
